import { Image } from '@chakra-ui/react';
import classNames from 'classnames';
import { FC } from 'react';

import styles from './styles.module.scss';
import arrowForward from 'assets/img/icons/chevron-forward.svg';
import doubleArrowForward from 'assets/img/icons/double-chevron-forward.svg';
import { useTranslation } from 'react-i18next';

interface Props {
  onPageChanged: (page: number) => void;
  pageCount: number;
  currentPage: number;
}

const Pagination: FC<Props> = ({ onPageChanged, pageCount, currentPage }) => {
  const { t } = useTranslation();

  const prevPageIsDisabled = currentPage === 1;
  const nextPageIsDisabled = currentPage === pageCount;

  return (
    <div className={styles.pagination}>
      <button
        className={classNames(styles.prev, {
          [styles.disabled]: prevPageIsDisabled,
        })}
        onClick={prevPageIsDisabled ? undefined : () => onPageChanged(1)}
      >
        <Image
          src={doubleArrowForward}
          width="14px" height="24px"
          alt=""
          className={styles.doubleArrow__left}
        />
      </button>
      <button
        className={classNames(styles.prev, {
          [styles.disabled]: prevPageIsDisabled,
        })}
        onClick={
          prevPageIsDisabled ? undefined : () => onPageChanged(currentPage - 1)
        }
      >
        <Image
          src={arrowForward}
          className={styles.arrow__left}
          width="8px" height="16px"
          alt=""
        />
      </button>
      <span className={styles.pageState}>
        {t('pageOf', { current: currentPage, total: pageCount })}
      </span>
      <button
        className={classNames(styles.next, {
          [styles.disabled]: nextPageIsDisabled,
        })}
        onClick={
          nextPageIsDisabled ? undefined : () => onPageChanged(currentPage + 1)
        }
      >
        <Image src={arrowForward} width="8px" height="16px" alt="" />
      </button>
      <button
        className={classNames(styles.next, {
          [styles.disabled]: nextPageIsDisabled,
        })}
        onClick={
          nextPageIsDisabled ? undefined : () => onPageChanged(pageCount)
        }
      >
        <Image src={doubleArrowForward} width="14px" height="24px" alt="" />
      </button>
    </div>
  );
};

export default Pagination;
